import Review from '@/models/Review'
import Api from '@/api'
import Job from '@/models/Job'
import { each, find, findIndex } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {}
  },

  mutations: {
    setReviewList(state, reviews) {
      each(reviews, review => {
        const exist = find(state.list, { id: review.id })
        if (!exist) {
          state.list.push(new Review(review))
        }
      })
    },

    setReviewListMeta(state, meta) {
      state.listMeta = meta
    },

    setReviewListItemDetails(state, review) {
      const index = findIndex(state.list, { id: review.id })
      state.list[index].body = review.body
    },

    clearReviewList(state) {
      state.list = []
      state.listMeta = {}
    },

    clearReviewListItemDetails(state, id) {
      const index = findIndex(state.list, { id: id })
      state.list.splice(index, 1)
    }
  },

  actions: {
    async getReviews({ commit }, params) {
      let query = Job.page(params.page || 1)
        .custom(`tools/${params.id}/reviews`)
        .limit(params.limit)

      const res = await query.get(params)

      commit('setReviewList', res.data)
      commit('setReviewListMeta', res.meta)
    },

    async createReview({ commit, state }, formData) {
      await Api.post(`tools/${formData.id}/reviews`, formData)
    }
  }
}
